<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_xi">FERRUCCIO BUSONI AND HIS LEGACY</a></p><a id="page_xi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Fm01.vue?e9c64fb6